import * as __WEBPACK_EXTERNAL_MODULE__storeFactory_js_7b8f9a77__ from "./storeFactory.js";
var __webpack_exports__storeFactory = __WEBPACK_EXTERNAL_MODULE__storeFactory_js_7b8f9a77__.storeFactory;
export { __webpack_exports__storeFactory as storeFactory };
